/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：dCsi
 */

// removed by extract-text-webpack-plugin
module.exports = {
  "coco-alert-icon": "coco-alert-icon_2BXrH"
}

/***/
